diy.angular.registerFactory('diyfmitemmodel', [ function() {
    
    // constructor
    var diyfmitemmodel = function(itemResource, source) {
        this._itemResource = itemResource;
        this._source = source;
        this._hash = null;
    };

    // public methods
    angular.extend(diyfmitemmodel.prototype, {
        getHash: function() {
            if (!this._hash) {
                this._hash = JSON.stringify({id: this.getId(), sourceName: this.getSource().getName()});
            }

            return this._hash;
        },
        getResource: function() {
            return this._itemResource;
        },
        setResource: function(resource) {
            // invalidate hash
            this._hash = null;
            return this._itemResource = resource;
        },
        getId: function() {
            return this._itemResource.id;
        },
        getSource: function() {
            return this._source;
        },
        getThumb: function() {
            return this._itemResource.thumb;
        },
        getPreview: function() {
            return this._itemResource.preview;
        },
        getFile: function() {
            return this._itemResource.file;
        },
        setThumb: function(thumb) {
            this._itemResource.thumb = thumb;
        },
        setPreview: function(preview) {
            this._itemResource.preview = preview;
        },
        canSelect: function() { 
            return typeof this.getId() !== 'undefined';
        },
        canMove: function() { 
            return false; 
        },
        hasName: function() {
            return false;
        }
    });    
    
    return diyfmitemmodel
}]);




/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/models/diyfmitemmodel.js
 ** module id = 958
 ** module chunks = 0
 **/